import React from 'react'

// Based on: https://stackoverflow.com/a/55857792

export const escapedNewLineToLineBreakTag = (input: string) =>
	input
		.split('\n')
		.map((item, index) => (index === 0 ? item : [<br key={index} />, item]))
